/**
 * Admin guide 7 — caching: what is kept, how long, when it refreshes —
 * every duration read live from the engine settings.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { seconds } from '../../settings/section-draft';
import { Rows, V } from '../guide-ui';

export const CachingSection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <Rows
    stamp="What is kept"
    head={['What', 'Kept', 'Refreshed']}
    rows={[
      ['Board, day preview, editor previews', 'Not cached', 'Worked out on every open; re-read after every save'],
      ['Per-drop SMSWiser stats', 'On the drop', <>Every <V>{s.statsRereadMin} min</V>, until <V>{s.statsFreshHours} h</V> after the send</>],
      ['Text rankings (texts over N days)', <>Shared copy, <V>{s.textRankingCopyHours} h</V></>, <>Warmed every <V>{s.textRankingWarmHours} h</V>, so the editor and the fill never wait</>],
      ['List performance tags', <V>{s.listTagsCacheHours} h</V>, 'When it expires'],
      ['Dynamic list groups', <>Last answer, <V>{s.groupTagsLastDays} days</V></>, <>A fresh read if it takes under <V>{seconds(s.groupTagsBudgetMs)}</V>; else the last answer, refreshed in the background</>],
      ['Route-test winner', 'On today’s run', 'Expires with the day'],
    ]}
  />
);
